import NoBuildings from './NoBuildings';

export default NoBuildings;



// WEBPACK FOOTER //
// ./src/components/Buildings/NoBuildings/index.js